(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/router/assets/javascripts/marketplace-retail.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/router/assets/javascripts/marketplace-retail.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const DocumentTitle = svs.components.lbUtils.DocumentTitle;
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link,
  Route = _ReactRouterDOM.Route;
const _svs$ui = svs.ui,
  ButtonGroup = _svs$ui.ReactButtonGroup,
  Button = _svs$ui.Button;
const Skeleton = svs.components.lbUi.Skeleton;
const _svs$components$marke = svs.components.marketplaceData,
  selectors = _svs$components$marke.selectors,
  teams = _svs$components$marke.teams;
const groupTypeNames = svs.components.marketplaceData.constants.groupTypeNames;
const trackEvent = svs.components.analytics.trackEvent;
const chatData = svs.components.chat.chatData;
const lazy = svs.components.lbUtils.lazy.lazy;
const TabsLoader = svs.marketplace.components.router.TabsLoader;
const RedirectToTeamSlugContainer = svs.components.marketplace.redirectToSlug.RedirectToTeamSlugContainer;
const GameSkeleton = svs.components.marketplace.gameList.GameSkeleton;
const BrowseGamesLoader = () => React.createElement("div", {
  className: "search-page search-page-v2",
  "data-testid": "qa-search-page-loading"
}, React.createElement(DocumentTitle, {
  title: "S\xF6k andelsspel"
}), React.createElement("div", {
  className: "browse-games-info"
}, React.createElement("div", {
  className: "browse-games-info-search"
}, React.createElement("div", {
  className: "browse-games-search-input"
}, React.createElement(Skeleton, {
  height: 3,
  numLines: 1,
  style: {
    width: '100%'
  }
})), React.createElement("div", {
  style: {
    minWidth: '120px'
  }
}, React.createElement(Skeleton, {
  height: 3,
  numLines: 1,
  style: {
    width: '100%'
  }
})))), React.createElement("div", {
  className: "marketplace-browse-games-search-results"
}, React.createElement("div", {
  className: "retail-browse-games-results-loading-state",
  "data-testid": "qa-browse-games-route-loading"
}, React.createElement("div", {
  style: {
    display: 'inline-flex',
    flexDirection: 'column'
  }
}, React.createElement(GameSkeleton, null), React.createElement(GameSkeleton, null), React.createElement(GameSkeleton, null)))));
const RetailViewMaster = lazy('react:retail-view', () => svs.marketplace.components.retailView.RetailViewMaster, {
  fallback: TabsLoader
});
const BrowseGames = lazy('/cl/marketplace/react:browse-games', () => svs.components.marketplace.browseGames.BrowseGamesV2, {
  fallback: BrowseGamesLoader
});
const RetailListPage = lazy('react:retail-list-page', () => svs.marketplace.components.retailListPage.RetailListPage, {
  fallback: TabsLoader
});
const RetailListOnboarding = lazy('react:retail-list-page', () => svs.marketplace.components.retailListPage.RetailListOnboarding, {
  fallback: TabsLoader
});
const retailTeamBaseRoute = '/ombudslag/:groupId([0-9]+):retailerPathName([-\\w]*)?';
const withMenu = Component => props => {
  const location = props.location;
  const options = [{
    key: 'list-retailers',
    label: 'Mina butiker',
    path: '/ombudslag'
  }, {
    key: 'find-retailers',
    label: 'Hitta butiker',
    path: '/hitta-andelsspel'
  }];
  return React.createElement("div", {
    className: "marketplace-retail marketplace-retail-background"
  }, React.createElement(DocumentTitle, {
    title: "Butiksandelar - Spela tillsammans | Svenska Spel"
  }), React.createElement("div", {
    className: "marketplace-retail-menu"
  }, React.createElement(ButtonGroup, {
    block: true,
    className: "marketplace-retail-button-group"
  }, options.map(_ref => {
    let key = _ref.key,
      label = _ref.label,
      path = _ref.path;
    const isActive = path === location.pathname;
    return  React.createElement(Button, {
      className: "qa-".concat(key, "-button"),
      inverted: isActive,
      key: path,
      transparent: !isActive
    }, React.createElement(Link, {
      className: "qa-".concat(key, "-link"),
      onClick: () => {
        trackEvent({
          category: 'Tillsammans',
          action: 'btn_interactions',
          opt_label: label.toUpperCase()
        });
      },
      to: path
    }, label))
;
  }))), React.createElement(Component, null));
};
const BrowseGamesWithMenu = withMenu(BrowseGames);
const RetailStartPageMaster = () => {
  const dispatch = useDispatch();
  const groupTypeFilter = groupTypeNames.RETAILER;
  const offset = useSelector(selectors.teams.selectRetailerTeamsOffset);
  const hasFetchedRetailers = typeof offset === 'number';
  const fetchNextRetailersAndTeams = () => dispatch(teams.actions.fetchNextRetailersAndTeamsAction({
    groupTypeFilter,
    offset
  }));
  const getUnread = () => dispatch(chatData.actions.getUnread());
  const loggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  useEffect(() => {
    if (loggedIn) {
      getUnread();
      if (!hasFetchedRetailers) {
        fetchNextRetailersAndTeams();
      }
    }
  }, []);
  const hasRetailers = useSelector(selectors.teams.getRetailers).filter(retailer => retailer.isFollowing).length > 0;
  const loading = useSelector(state => state.Teams.loading || !state.Teams.hasFetched && loggedIn);
  if (loading && !hasRetailers) {
    return React.createElement(RetailListPage, null);
  }
  if (hasRetailers) {
    return React.createElement(RetailListPage, null);
  }
  return React.createElement(RetailListOnboarding, null);
};
const MarketplaceRetail = () => {
  const switchedRoutes = [{
    component: withMenu(RetailStartPageMaster),
    exact: true,
    path: '/ombudslag'
  }, {
    component: RetailViewMaster,
    path: retailTeamBaseRoute,
    exact: false
  }, {
    component: BrowseGamesWithMenu,
    exact: false,
    label: 'Sök andelsspel',
    path: '/hitta-andelsspel'
  }];
  return React.createElement(React.Fragment, null, React.createElement(Route, {
    component: RedirectToTeamSlugContainer,
    exact: true,
    key: "team_redirect",
    path: "".concat(retailTeamBaseRoute, ":additionalPath(/.*?)*")
  }), switchedRoutes.map(_ref2 => {
    let path = _ref2.path,
      exact = _ref2.exact,
      component = _ref2.component,
      render = _ref2.render;
    return React.createElement(Route, {
      component: component,
      exact: exact,
      key: path,
      path: path,
      render: render
    });
  }));
};
setGlobal('svs.marketplace.components.router.MarketplaceRetail', MarketplaceRetail);

 })(window);